import store from 'src/redux/store';

export const getLastRegistrationDateLimitDays = () => {
  return (store.getState().config.data as any)?.Recruitment?.lastRegistrationDateBeforeDays ?? 10;
};
